"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const IdentifiersToolTip = () => (react_1.default.createElement(CustomToolTip_1.default, { type: '?', info: react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("p", null, "These are codes used by the music industry that uniquely identify publishers or publishing entities."),
        react_1.default.createElement("p", null, "If you do not have any of these identifiers, please leave them blank.")) }));
exports.default = IdentifiersToolTip;
